import {inject, Injectable} from '@angular/core';
import {FilesApiService} from "../services-api/files-api.service";
import {UploadProgressService} from "./upload-progress.service";
import {ErrorService} from "./error.service";
import {HttpEventType} from "@angular/common/http";
import {defaultFileParams} from "../models/default-file-params";
import {FileParams, UploadFileData} from "../types/file.types";

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  private filesApiService: FilesApiService = inject(FilesApiService);
  private uploadProgressService: UploadProgressService = inject(UploadProgressService);
  private errorService: ErrorService = inject(ErrorService);

  public async uploadFile(uploadFileData: UploadFileData): Promise<FileParams> {
    return new Promise((resolve, reject) => {
      this.filesApiService.uploadFile(uploadFileData).subscribe({
        next: (event) => {
          const progress = this.handleUploadEvent(event);
          this.uploadProgressService.updateProgress({
            progress: progress.progress,
            completed: progress.completed,
            fileName: uploadFileData.fileName,
            fileType: 'file',
          });

          if (event.type === HttpEventType.Response) {
            setTimeout(() => {
              const fileParams = event.body;
              resolve(fileParams || defaultFileParams);
              this.uploadProgressService.resetProgress();
            }, 300);
          }
        },
        error: (error) => {
          this.errorService.handleError(error);
          this.uploadProgressService.resetProgress();
          reject(error);
        }
      });
    });
  }

  private handleUploadEvent(event: any): {progress: number, completed: boolean} {
    switch (event.type) {
      case HttpEventType.UploadProgress:
        const progress = Math.round(100 * event.loaded / (event.total || 1));
        return { progress, completed: false };
      case HttpEventType.Response:
        return { progress: 100, completed: true };
      default:
        return { progress: 0, completed: false };
    }
  }
}
